module.exports = __webpack_public_path__ + "img/right_worm_n4_1.prt.b4a6029b.jpg";